import { Message } from "domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { LinkedinCompanyBlacklist } from "domain/entities/linkedincompanyblacklist";

class LinkedinCompanyBlacklistRepository {
  async getAll(filter?: any): Promise<Message<LinkedinCompanyBlacklist[]>> {
    const response = await httpClient.get(`/linkedinCompanyBlacklist`, {
      params: filter,
    });
    return response.data;
  }

  async create(input: { companyName: string; matchType: string; lastModifiedBy: string }): Promise<Message<LinkedinCompanyBlacklist>> {
    const response = await httpClient.post(`/linkedinCompanyBlacklist`, {
      data: input,
    });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/linkedinCompanyBlacklist/${id}`);
    return response.data;
  }
}

export default new LinkedinCompanyBlacklistRepository();
